










































import { Component, Vue } from 'vue-property-decorator';
import Divider from '@/components/common/Divider.vue';

@Component({
  components: {
    Divider,
  },
})
export default class Footer extends Vue {
  get thisYear() {
    return this.$dayjs().format('YYYY');
  }
}
